import {createActionGroup, emptyProps} from '@ngrx/store';
import {
  EditNotificationPreferencesValue,
  EditPatronValue,
  Patron,
  PATRON_FEATURE_KEY,
  PatronAccountStatus,
  PatronNotificationPreferences,
  PatronReferenceOptions,
  PatronRelationships,
  PatronSettingsQuickTogglesValue,
  RelatedPatron
} from './patron.types';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {ListData} from '@aviary/store/common/common.types';
import {Checkout} from '@store/checkouts/checkouts.types';
import {Hold, ReadyForPickupHolds} from '@store/holds/holds.types';
import {PatronBalanceTransaction} from '@store/balance/balance.types';

export const PatronActions = createActionGroup({
  source: PATRON_FEATURE_KEY,
  events: {
    'Initialize Auth Token': emptyProps(),
    'Initialize Auth Token Success': (authToken: string) => ({authToken}),
    'Initialize Auth Token No Auth': emptyProps(),
    'Initialize Auth Token Failure': (error: unknown) => ({error}),

    'Reload Auth Patron': emptyProps(),
    'Load Auth Patron Success': (patron: Patron) => ({patron}),
    'Load Auth Patron Failure': (error: unknown) => ({error}),

    'Show Login Dialog': (recordToPlaceHold?: CatalogRecord) => ({recordToPlaceHold}),

    'Login Patron With Email': (email: string, password: string, recordToPlaceHold?: CatalogRecord) => ({email, password, recordToPlaceHold}),
    'Login Patron With Card': (cardNumber: string, pin: string, recordToPlaceHold?: CatalogRecord) => ({cardNumber, pin, recordToPlaceHold}),
    'Login Patron Success': emptyProps(),
    'Login Patron Failure': (error: unknown) => ({error}),
    'Logout Patron': emptyProps(),
    'Reset Patron Password': (email: string) => ({email}),

    'Show Change Password': emptyProps(),
    'Change Password Success': emptyProps(),
    'Change Password Failure': (error: unknown) => ({error}),

    'Show Change Pin': emptyProps(),
    'Change Pin Success': emptyProps(),
    'Change Pin Failure': (error: unknown) => ({error}),

    'Load Account Status': emptyProps(),
    'Load Account Status Success': (status: PatronAccountStatus) => ({status}),
    'Load Account Status Failure': (error: unknown) => ({error}),

    'Load Patron Reference Options': emptyProps(), // For populating form select controls when creating or editing a patron.
    'Load Patron Reference Options Success': (options: PatronReferenceOptions) => ({options}),
    'Load Patron Reference Options Failure': (error: unknown) => ({error}),

    'Edit Patron': (formValue: EditPatronValue) => ({formValue}),
    'Edit Patron Success': (patron: Patron) => ({patron}),
    'Edit Patron Failure': (error: unknown) => ({error}),

    'Show Change Patron Email': emptyProps(),
    'Resend Patron Email Change Verification': emptyProps(),
    'Change Patron Email Success': (email: string) => ({email}),

    'Verify Patron Email Change': (code: string, verificationUUID: string) => ({code, verificationUUID}),
    'Verify Patron Email Change Success': emptyProps(),
    'Verify Patron Email Change Failure': emptyProps(),
    'Leave Verify Patron Email Change Landing': emptyProps(),

    'Load Notification Preferences': emptyProps(),
    'Load Notification Preferences Success': (preferences: PatronNotificationPreferences) => ({preferences}),
    'Load Notification Preferences Failure': (error: unknown) => ({error}),

    'Edit Notification Preferences': (formValue: EditNotificationPreferencesValue) => ({formValue}),
    'Edit Notification Preferences Success': (preferences: PatronNotificationPreferences) => ({preferences}),
    'Edit Notification Preferences Failure': (error: unknown) => ({error}),

    'Load Patron Relationships': emptyProps(),
    'Load Patron Relationships Success': (patronRelationships: PatronRelationships) => ({patronRelationships}),
    'Load Patron Relationships Failure': (error: unknown) => ({error}),

    'Update Patron Quick Toggles': (value: PatronSettingsQuickTogglesValue) => ({value}),

    // Dependents
    'Load Dependent Details': (dependentId: number) => ({dependentId}),
    'Load Dependent Details Success': (dependent: RelatedPatron) => ({dependent}),
    'Load Dependent Details Failure': (error: unknown) => ({error}),

    'Load Dependent Checkouts': (dependentId: number) => ({dependentId}),
    'Load Dependent Checkouts Success': (listData: ListData<Checkout>) => ({listData}),
    'Load Dependent Checkouts Failure': (error: unknown) => ({error}),

    'Load Dependent Ready For Pickup Holds': (dependentId: number) => ({dependentId}),
    'Load Dependent Ready For Pickup Holds Success': (data: ReadyForPickupHolds) => ({data}),
    'Load Dependent Ready For Pickup Holds Failure': (error: unknown) => ({error}),

    'Load Dependent On Hold Holds': (dependentId: number) => ({dependentId}),
    'Load Dependent On Hold Holds Success': (listData: ListData<Hold>) => ({listData}),
    'Load Dependent On Hold Holds Failure': (error: unknown) => ({error}),

    'Load Dependent Account Status': (dependentId: number) => ({dependentId}),
    'Load Dependent Account Status Success': (status: PatronAccountStatus) => ({status}),
    'Load Dependent Account Status Failure': (error: unknown) => ({error}),

    'Load Dependent Balance Transactions': (dependentId: number) => ({dependentId}),
    'Load Dependent Balance Transactions Success': (listData: ListData<PatronBalanceTransaction>) => ({listData}),
    'Load Dependent Balance Transactions Failure': (error: unknown) => ({error}),
    'Toggle Include All Dependent Balance Transactions': emptyProps(),
  }
});
